import React, {ChangeEvent, useState} from 'react';
import {Box, InputAdornment, Stack, TextField, Typography} from '@mui/material';
import {Search} from '@mui/icons-material';

interface SearchInputProps {
  initialQuery?: string;
  onSearch: (query: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({initialQuery = '', onSearch}) => {
  const [query, setQuery] = useState(initialQuery);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(query);
  };

  return (
    <Box sx={{py: 2}}>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <Typography variant='h1'>Search Results</Typography>
          <TextField
            variant='outlined'
            size='small'
            sx={{width: '400px', borderRadius: '6px'}}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Search sx={{color: 'black'}} />
                </InputAdornment>
              ),
            }}
            value={query}
            onChange={handleChange}
          />
        </Stack>
      </form>
    </Box>
  );
};

export default SearchInput;
